import React from 'react';
import { Button } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { PatientsTable, PrivateLayout } from '../components';
import { FeatureGuard } from '../components/multi-tenant/FeatureGuard';
import { navigateToPatientsNew } from '../redux';

export const PatientsView = () => {
  const dispatch = useDispatch();
  const renderButton = () => {
    return (
      <FeatureGuard contentKey='patient-management.manage'>
        <Button
          variant='secondary-new'
          className='pe-3 px-3 btn-addPatient'
          size='sm'
          onClick={() => dispatch(navigateToPatientsNew())}
          data-testid='cmx__add-patient-button'>
          <i className='fa-light fa-user-injured me-2'></i> Add Patient
        </Button>
      </FeatureGuard>
    );
  };
  return (
    <PrivateLayout
      pageTitle='patients'
      pageIcon={<i className='fa-light fa-user-injured me-2'></i>}
      subtoolbarChildren={renderButton()}>
      <PatientsTable enableExternalFilters />
    </PrivateLayout>
  );
};
